import { Component, inject, type OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Organizations } from '@core/auth/organizations';
import { Routes } from '@core/routes/routes';
import { TranslationModule } from '@fino-ui/translation';
import Keycloak from 'keycloak-js';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  imports: [TranslationModule],
  styleUrls: ['./home.component.sass'],
})
export class HomeComponent implements OnInit {
  private readonly authService = inject(Keycloak);
  private readonly router = inject(Router);

  ngOnInit() {
    const userProfile = this.authService.tokenParsed;
    const organizations = Object.values(Organizations);

    const navigateToOverview = organizations.some((org) =>
      userProfile?.organization?.includes(org),
    );
    if (navigateToOverview) {
      this.router.navigate([Routes.TicketOverview]);
    }
  }
}
